class subCollection extends HTMLElement {
    constructor() {
      super();

      const self = this;

      const collectionId = document.querySelector(".collection-content").getAttribute('data-section-id');
      const bannerId = document.querySelector(".js-collection-banner").getAttribute('data-section-id');

      this.sections = {
        banner: {
            sectionId: bannerId,
            nodeId: "collectionBanner"
        },
        main: {
            sectionId: collectionId,
            nodeId: "mainCollection"
        }
      };

      this.ajaxCollectionEl = document.querySelector(`#${this.sections.main.nodeId}`);
      this.collectionBanner = document.querySelector(`#${this.sections.banner.nodeId}`);
      this.subCollectionItems = this.querySelectorAll("[js-sub-collection-item]");

      this.subCollectionItems.forEach(item => {
        item.addEventListener('click', function(e) {
            e.preventDefault();
            const collectionHandle = this.dataset.collectionHandle;
            self.initAjaxCollection(collectionHandle, this);
        });
      });
    }

    initAjaxCollection(handle, targetEl) {
        this.changeActiveState(targetEl);
        this.updateHistoryState(handle);
        this.renderCollectionBanner(handle);
        this.renderAjaxCollection(handle);
    }

    changeActiveState(targetEl) {
        this.subCollectionItems.forEach(item => item.classList.remove("active"));
        targetEl.classList.add('active');
    }

    updateHistoryState(handle) {
        const newUrl = `${window.location.protocol}//${window.location.host}/collections/${handle}`;
        window.history.replaceState({path: newUrl}, '', newUrl);
    }

    renderCollectionBanner(handle) {
        const self = this;
        const url = `/collections/${handle}?section_id=${this.sections.banner.sectionId}`;
        this.collectionBanner.classList.add("preloading");

        fetch(url).then(response => response.text()).then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            self.collectionBanner.innerHTML = doc.querySelector(`#${self.sections.banner.nodeId}`).innerHTML;
            self.collectionBanner.classList.remove("preloading");
        });
    }

    renderAjaxCollection(handle) {
        const self = this;
        const url = `/collections/${handle}?section_id=${this.sections.main.sectionId}`;
        this.ajaxCollectionEl.classList.add("preloading");

        fetch(url).then(response => response.text()).then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            self.ajaxCollectionEl.innerHTML = doc.querySelector(`#${self.sections.main.nodeId}`).innerHTML;

            document.dispatchEvent(new CustomEvent('swatch-item:init'));
            document.dispatchEvent(new CustomEvent("update-scroll:init"));
            document.dispatchEvent(new CustomEvent("layout-toggle:init"));
            document.dispatchEvent(new CustomEvent("infinite-scroll:init"));

            self.ajaxCollectionEl.classList.remove("preloading");
        });
    }
}
  
customElements.define('sub-collection', subCollection);
